import { ComponentBase } from '../component/component.base';
import { IComponentModalBase } from './component-modal.interface';

export abstract class ComponentModalBase extends ComponentBase implements IComponentModalBase {
    
}